import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [routeId, setRouteId] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setRouteId(data.route_id);
        if (data.payment_status === "paid") { setStatus("success"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts < 8) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-parchment-grain">
      <Card className="card-treasure p-10 max-w-md w-full text-center">
        {status === "checking" && (
          <>
            <Loader2 className="animate-spin mx-auto text-gold mb-4" size={48}/>
            <h1 className="font-display font-extrabold text-2xl text-ink-900">Verifica pagamento...</h1>
            <p className="text-ink-700 mt-2 text-sm">Stiamo confermando la tua transazione.</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="mx-auto text-forest mb-4 animate-bounce-in" size={64}/>
            <h1 className="font-display font-extrabold text-3xl text-ink-900">Pagamento riuscito!</h1>
            <p className="text-ink-700 mt-2">Hai sbloccato il percorso. Buona avventura!</p>
            <button onClick={() => navigate(`/routes/${routeId}`)} className="btn-tactile mt-6" data-testid="goto-route-btn">Apri il percorso</button>
          </>
        )}
        {(status === "error" || status === "expired" || status === "timeout") && (
          <>
            <XCircle className="mx-auto text-compass mb-4" size={64}/>
            <h1 className="font-display font-extrabold text-2xl text-ink-900">Qualcosa è andato storto</h1>
            <p className="text-ink-700 mt-2">{status === "expired" ? "Sessione scaduta" : "Pagamento non confermato"}</p>
            <button onClick={() => navigate("/")} className="btn-tactile mt-6">Torna alla home</button>
          </>
        )}
      </Card>
    </div>
  );
}
